
import {Vue} from "vue-property-decorator";
import Component from "vue-class-component";
import QrCodeStreamer from "@/components/QrCodeStreamer.vue";
import QrCodeMultiScannerWrapper from "@/components/qrcode/QrCodeMultiScannerWrapper.vue";
import QrCodeScannerWrapper from "@/components/qrcode/QrCodeScannerWrapper.vue";

@Component({
  components: {
    QrCodeMultiScannerWrapper,
    QrCodeScannerWrapper,
    QrCodeStreamer,
  },
})
export default class QrCodeTestComponent extends Vue {

  private loading: boolean = false;
  private result: string = null;
  private selectedComponent: string = null;
  private availableComponents: string[] = [
    "myloby-qr-code-streamer",
    "new-myloby-qr-code-streamer",
    "vue-qrcode-reader",
    "vue-qrcode-reader-vanilla",
    "vue-barcode-reader",
    "zxing",
    "html5-qrcode",
  ];

  private onDecodeParent(decodedString: string) {
    // Simulate API call
    if (decodedString) {
      this.loading = true;
      this.result = decodedString;
      this.$nextTick().then(() =>
        setTimeout(() => {
          this.loading = false;
          this.result = null;
        }, 2000),
      );
    }
  }
}
